export default __webpack_public_path__ + "static/media/report-bug.06da61ac.svg";